<template>
  <div class="panel">
    <div class="flex">
      <el-button-group class="switch-btns">
        <el-button
          :type="switchBtnKey === 'statisticsAgency' ? 'primary' : 'default'"
          @click="switchBtnHandler('statisticsAgency', 10)"
        >
          推广机构数量
        </el-button>
        <el-button
          :type="switchBtnKey === 'statisticsCourse' ? 'primary' : 'default'"
          @click="switchBtnHandler('statisticsCourse', 20)"
        >
          推广课程数量
        </el-button>
        <el-button
          :type="switchBtnKey === 'statisticsPrice' ? 'primary' : 'default'"
          @click="switchBtnHandler('statisticsPrice', 30)"
        >
          推广课程金额
        </el-button>
      </el-button-group>
    </div>
    <div id="line" />
  </div>
</template>

<script>

import { Line } from '@antv/g2plot';

export default {
  name: 'Home',
  components: {},
  props: {
    panelData: {
      type: Array,
      default: () => ([]),
    },
    queryType: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      switchBtnKey: 'statisticsAgency',
      linePlot: null,
    };
  },
  watch: {
    panelData: {
      handler() {
        this.renderColumn(this.panelData);
      },
      deep: true,
    },
  },
  methods: {
    // 切换显示机构人员
    switchBtnHandler(val, type) {
      this.switchBtnKey = val;
      this.$emit('update:queryType', type);
    },
    // 渲染柱状图
    renderColumn(data) {
      if (this.linePlot) {
        this.linePlot.destroy();
        this.linePlot = null;
      }
      let alias = '';
      let xField = '';
      let label = '';
      if (this.switchBtnKey === 'statisticsAgency') {
        alias = '推广机构数量';
        xField = 'xvalue';
        label = {
          formatter: (v) => `${v}次`,
        };
      }
      if (this.switchBtnKey === 'statisticsCourse') {
        alias = '推广课程数量';
        xField = 'xvalue';
        label = {
          formatter: (v) => `${v}次`,
        };
      }
      if (this.switchBtnKey === 'statisticsPrice') {
        alias = '推广课程金额';
        xField = 'xvalue';
        label = {
          formatter: (v) => `${v}元`,
        };
      }
      this.linePlot = new Line('line', {
        data,
        xField,
        yField: 'yvalue',
        seriesField: 'targetName',
        // columnStyle: {
        //   radius: [2, 2, 0, 0],
        // },
        color: ['#FF7223', '#1DD1A1', '#2BADFF'],
        smooth: true,
        point: {
          size: 7,
          shape: 'circle',
          style: {
            stroke: '#fff',
            lineWidth: 1,
          },
        },
        yAxis: {
          label,
        },
        meta: {
          value: {
            alias,
          },
        },
        tooltip: {
          fields: ['targetName', 'yvalue'],
          formatter: (datum) => ({ name: `${alias}(${datum.targetName})`, value: datum.yvalue }),
        },
      });
      this.linePlot.render();
      this.linePlot.on('element:click', () => {
        this.$emit('elementClick');
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.panel{
  .header{
    display: flex;
    overflow-y: auto;
    .item{
      padding: 16px;
      display: flex;
      flex-direction: column;
      background: #F7F7F7;
      margin-right: 15px;
      flex: 1;
      .label{
        color:#979797;
        font-size: 14px;
        font-weight: 500;
      }
      .value{
        font-size: 32px;
        margin-top: 12px;
        font-weight: 800;
        color: $--base-color-main;
        display: flex;
        align-items: center;
        b{
          font-size: 18px;
        }
      }
    }
  }
  .border-bottom{
    border-bottom: 1px solid #EBEBEB;
  }
  .switch-btns{
    margin-bottom: 20px;
  }
  #line{
    height: 300px;
  }
  .pay-amount{
    display: flex;
    .items{
      background: #F7F7F7;
      margin-right: 16px;
      min-width: 170px;
      display: flex;
      flex-direction: column;
      padding: 16px;
      .item{
        margin-bottom: 25px;
        .label{
          color:#979797;
          font-size: 14px;
          font-weight: 500;
        }
        .value{
          font-size: 32px;
          margin-top: 12px;
          font-weight: 800;
          color: $--base-color-main;
          display: flex;
          align-items: center;
            b{
              font-size: 18px;
            }
        }
      }
    }
    #line{
      flex: 1,
    }
  }
}
</style>
